export const prefectures = [
  { is_default: true, label: '都道府県', value: '' },
  { is_default: false, label: '北海道', value: '北海道' },
  { is_default: false, label: '青森県', value: '青森県' },
  { is_default: false, label: '岩手県', value: '岩手県' },
  { is_default: false, label: '宮城県', value: '宮城県' },
  { is_default: false, label: '秋田県', value: '秋田県' },
  { is_default: false, label: '山形県', value: '山形県' },
  { is_default: false, label: '福島県', value: '福島県' },
  { is_default: false, label: '茨城県', value: '茨城県' },
  { is_default: false, label: '栃木県', value: '栃木県' },
  { is_default: false, label: '群馬県', value: '群馬県' },
  { is_default: false, label: '埼玉県', value: '埼玉県' },
  { is_default: false, label: '千葉県', value: '千葉県' },
  { is_default: false, label: '東京都', value: '東京都' },
  { is_default: false, label: '神奈川県', value: '神奈川県' },
  { is_default: false, label: '新潟県', value: '新潟県' },
  { is_default: false, label: '富山県', value: '富山県' },
  { is_default: false, label: '石川県', value: '石川県' },
  { is_default: false, label: '福井県', value: '福井県' },
  { is_default: false, label: '山梨県', value: '山梨県' },
  { is_default: false, label: '長野県', value: '長野県' },
  { is_default: false, label: '岐阜県', value: '岐阜県' },
  { is_default: false, label: '静岡県', value: '静岡県' },
  { is_default: false, label: '愛知県', value: '愛知県' },
  { is_default: false, label: '三重県', value: '三重県' },
  { is_default: false, label: '滋賀県', value: '滋賀県' },
  { is_default: false, label: '京都府', value: '京都府' },
  { is_default: false, label: '大阪府', value: '大阪府' },
  { is_default: false, label: '兵庫県', value: '兵庫県' },
  { is_default: false, label: '奈良県', value: '奈良県' },
  { is_default: false, label: '和歌山県', value: '和歌山県' },
  { is_default: false, label: '鳥取県', value: '鳥取県' },
  { is_default: false, label: '島根県', value: '島根県' },
  { is_default: false, label: '岡山県', value: '岡山県' },
  { is_default: false, label: '広島県', value: '広島県' },
  { is_default: false, label: '山口県', value: '山口県' },
  { is_default: false, label: '徳島県', value: '徳島県' },
  { is_default: false, label: '香川県', value: '香川県' },
  { is_default: false, label: '愛媛県', value: '愛媛県' },
  { is_default: false, label: '高知県', value: '高知県' },
  { is_default: false, label: '福岡県', value: '福岡県' },
  { is_default: false, label: '佐賀県', value: '佐賀県' },
  { is_default: false, label: '長崎県', value: '長崎県' },
  { is_default: false, label: '熊本県', value: '熊本県' },
  { is_default: false, label: '大分県', value: '大分県' },
  { is_default: false, label: '宮崎県', value: '宮崎県' },
  { is_default: false, label: '鹿児島県', value: '鹿児島県' },
  { is_default: false, label: '沖縄県', value: '沖縄県' },
]
